export default __webpack_public_path__ + "static/media/351.c1067daa.png";